var map = {
	"./gallery_00.jpg": 1969,
	"./gallery_01.jpg": 1970,
	"./gallery_02.jpg": 1971,
	"./gallery_03.jpg": 1972,
	"./gallery_04.jpg": 1973,
	"./gallery_05.jpg": 1974,
	"./gallery_06.jpg": 1975,
	"./gallery_07.jpg": 1976,
	"./gallery_08.jpg": 1977,
	"./gallery_09.jpg": 1978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1968;